import React from 'react';
import { FiSearch } from 'react-icons/fi';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const SearchField: React.FC<SearchFieldProps> = ({ value, onChange, placeholder }) => (
  <div className="search-field">
    <FiSearch aria-hidden="true" />
    <input
      type="text"
      aria-label={placeholder}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default SearchField;
